import { render, staticRenderFns } from "./flowShipment.vue?vue&type=template&id=56242ad8&scoped=true&"
import script from "./flowShipment.vue?vue&type=script&lang=js&"
export * from "./flowShipment.vue?vue&type=script&lang=js&"
import style0 from "./flowShipment.vue?vue&type=style&index=0&id=56242ad8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56242ad8",
  null
  
)

export default component.exports